import { gemtypeLists, shapeLists, colorLists, clarityLists, originLists, treatmentLists } from '../utils/Utils';
import { CreateWooDescription } from '../functions/functions';

const WOO_BASE_URL = 'https://gemnoble.com/wp-json/wc/v3';
const WOO_TOKEN = 'Y2tfMTc3NjU5ZmFmYmRhM2I4MzAzYThlZDNkN2VhYmMzYjY4ZjlhYTc0OTpjc19kYmFiNTgyODFjMzFhMTFiZDc0ZGE1MTM2OWQ2N2ViNzRhNzIyODdl';

const wooHeaders = () => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Basic ${WOO_TOKEN}`);
    return headers;
};

export const createWooProduct = (productData) => {
    return new Promise((resolve, reject) => {
        fetch(`${WOO_BASE_URL}/products/`, {
            method: 'POST',
            headers: wooHeaders(),
            body: JSON.stringify(productData),
            redirect: 'follow'
        })
            .then(response => response.text())
            .then(result => resolve(JSON.parse(result)))
            .catch(error => reject(error));
    });
};

export const updateWooProduct = (id, productData) => {
    return new Promise((resolve, reject) => {
        fetch(`${WOO_BASE_URL}/products/${id}`, {
            method: 'PUT',
            headers: wooHeaders(),
            body: JSON.stringify(productData),
            redirect: 'follow'
        })
            .then(response => response.text())
            .then(result => resolve(JSON.parse(result)))
            .catch(error => reject(error));
    });
};

export const deleteWooProduct = (id) => {
    return new Promise((resolve, reject) => {
        fetch(`${WOO_BASE_URL}/products/${id}?force=1`, {
            method: 'DELETE',
            headers: wooHeaders(),
            redirect: 'follow'
        })
            .then(response => response.text())
            .then(result => resolve(JSON.parse(result)))
            .catch(error => reject(error));
    });
};

/**
 * Builds a WooCommerce product payload from a gem object.
 * Keeps the existing woo.status (publish/private).
 */
export const buildWooPayload = (gem) => {
    const findVal = (list, key) => {
        const idx = list.findIndex(i => i.key === key);
        return idx >= 0 ? list[idx].value : key;
    };
    const findWooId = (key) => {
        const idx = gemtypeLists.findIndex(i => i.key === key);
        return idx >= 0 ? gemtypeLists[idx].woo_id : 1;
    };

    return {
        name: gem.title,
        slug: gem.id,
        sku: gem.id,
        type: 'simple',
        status: gem.woo?.status || 'private',
        sold_individually: true,
        description: CreateWooDescription(gem),
        regular_price: gem.price,
        categories: [{ id: findWooId(gem.type) }],
        images: [...(gem.images || []), ...(gem.certimgs || [])],
        attributes: [
            { id: 4,  position: 0, name: 'Gemstone Type',  visible: true, variation: true, options: findVal(gemtypeLists, gem.type) },
            { id: 10, position: 1, name: 'Carat',          visible: true, variation: true, options: gem.weight },
            { id: 5,  position: 2, name: 'Shape',          visible: true, variation: true, options: findVal(shapeLists, gem.shape) },
            { id: 1,  position: 3, name: 'Color',          visible: true, variation: true, options: findVal(colorLists, gem.color) },
            { id: 9,  position: 4, name: 'Clarity Grade',  visible: true, variation: true, options: findVal(clarityLists, gem.clarity) },
            { id: 6,  position: 5, name: 'Origin',         visible: true, variation: true, options: findVal(originLists, gem.origin) },
            { id: 7,  position: 6, name: 'Treatment',      visible: true, variation: true, options: findVal(treatmentLists, gem.treatment) },
            { id: 8,  position: 7, name: 'Certification',  visible: true, variation: true, options: gem.certificate },
            { id: 2,  position: 8, name: 'Brand',          visible: true, variation: true, options: gem.certificate },
        ],
        meta_data: gem.videos?.length > 0
            ? [{ id: 23671, key: '_woodmart_product_video', value: gem.videos[0].source_url }]
            : [],
    };
};

/**
 * Syncs a gem (that already has gem.woo) to WooCommerce.
 * Returns the updated woo object from WooCommerce.
 */
export const syncGemToWoo = (gem) => {
    if (!gem.woo?.id) return Promise.reject(new Error('Gem is not listed on WooCommerce'));
    return updateWooProduct(gem.woo.id, buildWooPayload(gem));
};
